import * as React from 'react';
import * as classNames from 'classnames';

import style from './StructureEditor.less';
import { WFormData } from '../forms/WFormFramework';
import { WTable } from '../table/WTable';
import { lazyInject } from '../../services/inversify';
import { StructureService } from '../../services/structure_service';
import { ContextService } from '../../services/context_service';
import DialogWrapper from '../dialog/dialog_wrapper';
import { StructureEditorForm } from './StructureEditorForm';
import { WActionButton } from '../elements/WActionButton';
import form_attribute from './form_attribute.json';


export interface StructureEditorDetailProps extends React.ClassAttributes<any> {
    entitySelected: string;
    structureData: any;
    modul: string;
    developerMode?: boolean;
    typeCountInfo?: Array<any>;
    externalHeaderElements?: Array<JSX.Element>;
    customClass?: string;
    sendEntityStructure(entityName: string, entityStucture: any): any;
    setRefEntityStructure(refValues: any): any;
}

export interface StructureEditorDetailState {
    keySelected: string;
    indexSelected: number;
    showAttributeForm: boolean;
    structureData: any;
}

export class StructureEditorDetail extends React.Component<StructureEditorDetailProps, StructureEditorDetailState>  {

    constructor(props: any) {
        super(props);

        this.onSelect = this.onSelect.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.getCustomActions = this.getCustomActions.bind(this);
        this.translateType = this.translateType.bind(this);
        this.cellRendererType = this.cellRendererType.bind(this);
        this.cellRendererOpts = this.cellRendererOpts.bind(this);
        this.onFormClose = this.onFormClose.bind(this);
        this.onFormSave = this.onFormSave.bind(this);
        this.setNewRef = this.setNewRef.bind(this);
        this.onCheckSetNewRef = this.onCheckSetNewRef.bind(this);
        this.cellRendererRequired = this.cellRendererRequired.bind(this);
        this.onChangeInLineRequired = this.onChangeInLineRequired.bind(this);
        this.onBatchDelete = this.onBatchDelete.bind(this);
        this.cellRendererRecht = this.cellRendererRecht.bind(this);

        this.state = {
            keySelected: undefined,
            indexSelected: undefined,
            showAttributeForm: false,
            structureData: this.props.structureData
        };
    }

    @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(ContextService) private contextService: ContextService;

    private checkedRows: Array<any> = [];

    componentWillMount() {
        // console.log('StructureEditorService componentWillMount');
        // console.log(this.props.structureData);
    }

    render() {
        // console.log(this.props);
        // console.log(this.state);
        return (
            <div>
                {this.props.entitySelected ? this.renderAttributeTable() : 'Bitte Struktur wählen!'}
            </div>
        );
    }
    renderAttributeTable() {
        // console.log('TCI ?: ', this.props.typeCountInfo, this.state.indexSelected);
        let tableData: Array<any> = [];
        const structureData = this.state.structureData;
        if (!structureData[this.props.entitySelected]) {
            return 'Die gewählte Datenstruktur ist nicht mehr vorhanden.';
        }
        if (structureData && this.props.entitySelected && structureData[this.props.entitySelected].ATTS) {
            tableData = structureData[this.props.entitySelected].ATTS.map((s: any) => {
                return {
                    name: s.NAME,
                    info: s.INFO,
                    key: s.KEY,
                    type: s.TYPE,
                    opts: s.OPTS,
                    required: s.REQUIRED,
                    hidden: s.HIDDEN,
                    filter_mode: s.FILTER_MODE,
                    recht: s.RECHT,
                    gruppe: s.FIELD_GROUP
                };
            });
        }

        const addAttributeButton = <WActionButton
            tooltip='Feld erstellen'
            label=''
            key='add'
            action='add'
            onAction={() => this.setState({ showAttributeForm: true })}
        />;

        const delAttributeButton = <WActionButton
            tooltip='Ausgewählte Felder entfernen'
            label=''
            key='delete2'
            action='delete2'
            onAction={this.onBatchDelete}
        />;

        const time = Date.now();

        this.checkedRows = [];

        return (<div>
            <WTable
                tableId={new Date().getTime().toString()}
                entity=''
                data={tableData}
                columns={structureData[this.props.entitySelected].ATTS ? this.getColumns() : this.getColumns()}
                customActions={this.getCustomActions()}
                columnWidths={[null, null, null, 150, null, null, 150]}
                onAction={() => { }}
                externalHeaderElements={[addAttributeButton, delAttributeButton, ... this.props.externalHeaderElements]}
                showPagination={true}
                enableRowCheckbox={true}
                dataKeyAttribute='key'
                customClass={this.props.customClass ? this.props.customClass : null}
                onRowSelect={(row: any, checked: boolean, checkedRows: Array<any>) => {
                    console.log(checkedRows);
                    this.checkedRows = checkedRows;
                }}
            />
            {this.state.keySelected || this.state.showAttributeForm ? (
                <div>
                    <DialogWrapper
                        onAfterClose={this.onFormClose}
                    >
                        <StructureEditorForm
                            modul={this.props.modul}
                            key={'structureEditorForm_' + time}
                            entitySelected={this.props.entitySelected}
                            keySelected={this.state.keySelected}
                            structureData={structureData}
                            onFormCancel={this.onFormClose}
                            onFormSave={this.onFormSave}
                            typeCountInfo={this.props.typeCountInfo ? this.props.typeCountInfo[this.state.indexSelected] : undefined}
                        />
                    </DialogWrapper>
                </div>) : ''}
        </div>);
    }

    onFormClose() {
        const keySelected: string = undefined;
        const indexSelected: number = undefined;
        this.setState({ keySelected, indexSelected, showAttributeForm: false });
    }
    onFormSave(entityName: string, values: any) {
        console.log('StructureEditorDetail onFormSave values :', values);

        if (values.SET_NEW_REF) {
            values = this.setNewRef(values);
        }

        const structureData = this.state.structureData;
        if (!structureData[entityName].ATTS) {
            structureData[entityName].ATTS = [];
            structureData[entityName].ATTS.push(values);
        } else {
            const attIndex = structureData[this.props.entitySelected].ATTS.findIndex((a: any) => a.KEY === values.KEY);
            if (attIndex >= 0) {
                structureData[entityName].ATTS[attIndex] = values;
            } else {
                structureData[entityName].ATTS.push(values);
            }
        }

        this.props.sendEntityStructure(entityName, structureData[entityName]);
        this.setState({ structureData });
        this.onFormClose();
    }

    setNewRef(values: any) {
        if (values.SET_NEW_REF) {
            delete (values.SET_NEW_REF);
            const refStructure = this.props.setRefEntityStructure(values);

            values.OPTS = {
                IDENTIFIER: 'tid',
                INPUT: 'name',
                ENTITY: refStructure.SRC.id
            };
        }
        return values;
    }

    onSelect(row: any, indexSelected: number) {
        // console.log('SelectedRow', row);
        const keySelected = row.key;
        this.setState({ keySelected, indexSelected });
    }

    getColumns() {
        const columns = new Array<any>();

        const fulltextFilterMethod = (filter: any, row: any) => {
            // console.log(row);
            return row[filter.id] && (row[filter.id] + '').toLowerCase().indexOf(filter.value.toLowerCase()) !== -1;
        };

        if (this.props.developerMode) {
            const item_key: any = { accessor: 'key', Header: 'Schlüssel', id: 'key' };
            columns.push(item_key);
        }

        const item_name: any = { accessor: 'name', Header: 'Bezeichnung', id: 'name' };
        const item_info: any = { accessor: 'info', Header: 'Beschreibung', id: 'indo' };
        const item_type: any = { accessor: 'type', Header: 'Typ', id: 'type', Cell: this.cellRendererType };
        const item_required: any = { accessor: 'required', Header: 'Pflicht/Optional/Schlüssel', id: 'required', Cell: this.cellRendererRequired };
        const item_hidden: any = { accessor: 'hidden', Header: 'Sichtbarkeit', id: 'hidden', Cell: this.cellRenderer };
        const item_filter_mode: any = { accessor: 'filter_mode', Header: 'Filter-Modus', id: 'filter_mode', Cell: this.cellRenderer };
        const item_opts: any = { accessor: 'opts', Header: 'Auswahl', id: 'opts', Cell: this.cellRendererOpts };
        const item_recht: any = { accessor: 'recht', Header: 'Recht', id: 'recht', Cell: this.cellRendererRecht };
        const item_gruppe: any = { accessor: 'gruppe', Header: 'Gruppe', id: 'gruppe' };

        item_name.filterMethod = fulltextFilterMethod;
        item_info.filterMethod = fulltextFilterMethod;
        item_type.filterMethod = fulltextFilterMethod;
        item_required.filterMethod = fulltextFilterMethod;
        item_hidden.filterMethod = fulltextFilterMethod;
        item_filter_mode.filterMethod = fulltextFilterMethod;
        item_opts.filterMethod = fulltextFilterMethod;
        item_recht.filterMethod = fulltextFilterMethod;
        item_gruppe.filterMethod = fulltextFilterMethod;

        columns.push(item_name);
        columns.push(item_info);
        columns.push(item_type);
        columns.push(item_required);
        columns.push(item_hidden);
        columns.push(item_filter_mode);
        columns.push(item_opts);
        columns.push(item_recht);
        columns.push(item_gruppe);

        return columns;
    }
    cellRenderer(row: any) {
        const mapping: any = {
            required: 'REQUIRED',
            hidden: 'HIDDEN',
            filter_mode: 'FILTER_MODE'
        };
        const key = mapping[row.column.id];
        let attr: any;
        for (attr of form_attribute) {
            if (attr.key === key) {
                break;
            }
        }
        if (attr && attr.options) {
            const opts: any = {};
            for (const op of attr.options) {
                opts[op.value] = op.label;
            }
            if (opts[row.value]) {
                return opts[row.value];
            }
        }
        return '';
    }
    cellRendererRecht(row: any) {
        const access = this.contextService.get('tableAccess');
        if (Array.isArray(access)) {
            const item = access.find((i: any) => { return i.name === row.value; });
            if (item) {
                return item.info || item.name;
            }
        }
        return row.value;
    }
    cellRendererRequired(row: any) {
        for (const attr of form_attribute) {
            if (attr.key === 'REQUIRED') {
                const opts = [];
                for (const op of attr.options) {
                    opts.push(
                        <option
                            key={'opt_required_' + op.value}
                            value={op.value}
                        >
                            {op.label}
                        </option>
                    );
                }
                return (
                    <select onChange={(event) => this.onChangeInLineRequired(event, row)} value={row.value ? row.value : ''}>
                        key = {'sel_field_' + row.original.key}
                        {opts}
                    </select>
                );
            }
        }
        return '';
    }
    onChangeInLineRequired(event: any, row: any) {
        // console.log(event, row);
        const structureData = this.state.structureData;
        const atts = structureData[this.props.entitySelected].ATTS;
        const idx = atts.findIndex((a: any) => a.KEY === row.original.key);
        if (idx >= 0) {
            atts[idx].REQUIRED = event.target.value;
            this.setState({ structureData });
            const entity = this.props.entitySelected;
            this.props.sendEntityStructure(
                entity,
                structureData[entity]
            );
        }
    }
    cellRendererType(row: any) {
        const value = row.value;
        return this.translateType(value, row.index);
    }
    cellRendererOpts(row: any) {
        const value = row.value;
        if (value) {
            if (value instanceof Array) {
                return 'Liste';
            }
            if (value.ENTITY) {
                // console.log(value);
                let fieldData;
                if (typeof value.MODUL === 'string' && value.MODUL !== this.props.modul) {
                    // Referenzen auf andere Module
                    fieldData = this.structureService.getFieldInfo(value.MODUL, value.ENTITY, value.INPUT);
                    if (fieldData) {
                        return 'Referenz: ' + fieldData.entityTitel + ' (' + value.MODUL + ') / ' + fieldData.fieldName;
                    } else {
                        return 'Referenz: ' + value.ENTITY_NAME + ' (' + value.MODUL + ') / ' + value.INPUT;
                    }
                } else {
                    fieldData = this.structureService.getFieldInfo(this.props.modul, value.ENTITY, value.INPUT);
                    if (fieldData) {
                        return 'Referenz: ' + fieldData.entityTitel + ' / ' + fieldData.fieldName;
                    } else if (this.state.structureData[value.ENTITY]) {
                        return 'Referenz: ' + this.state.structureData[value.ENTITY].TITEL + ' / Bezeichnung';
                    } else {
                        return 'Referenz: "' + value.ENTITY + '" NICHT gefunden.';
                    }
                }
            }
        }
        return (
            <div>
                <label>
                    <input type='checkbox' onChange={() => this.onCheckSetNewRef(event, row)} defaultChecked={false} /> Neuer Katalog
                </label>
            </div>
        );
    }

    onCheckSetNewRef(event: any, row: any) {
        const structureData = this.state.structureData;
        const atts = structureData[this.props.entitySelected].ATTS;
        const idx = atts.findIndex((a: any) => a.KEY === row.original.key);
        if (idx >= 0) {
            const formData: WFormData = new WFormData();
            formData.setAllValues(atts[idx]);
            const values = formData.getAllValues();
            values.SET_NEW_REF = true;
            values.TYPE = 'INT';
            console.log('REF NEW: ', values);
            this.onFormSave(this.props.entitySelected, values);
        }
    }

    translateType(type: string, index: number) {
        let name = '';
        switch (type) {
            case 'INT':
                name = 'Ganzzahl';
                break;
            case 'DOUBLE':
                name = 'Dezimalzahl';
                break;
            case 'TEXT':
                name = 'Text';
                break;
            case 'DATE':
                name = 'Datum';
                break;
            case 'TIME':
                name = 'Zeit';
                break;
            case 'DATETIME':
                name = 'Datum/Zeit';
                break;
            case 'FILE':
                name = 'Datei';
                break;
            case 'CHECKBOX':
                name = 'Auswahlfeld';
                break;
            default: {
                if (type && type.substring(0, 4) === 'CHAR') {
                    name = 'Zeichenkette';
                }
            }
        }
        if (this.props.typeCountInfo && this.props.typeCountInfo[index] && this.props.typeCountInfo[index][type]) {
            name += ' (' + this.props.typeCountInfo[index][type] + 'x)';
        }
        return name;
    }
    getCustomActions() {
        const action = [
            {
                label: 'Feld bearbeiten',
                key: 'edit',
                func: this.onSelect,
                info: 'Feld bearbeiten'
            },
            {
                label: 'Feld löschen',
                key: 'delete',
                func: this.onDelete,
                info: 'Feld löschen'
            }
        ];
        return action;
    }

    onDelete(row: any) {
        if (confirm('Sind Sie sicher ? Das Feld wird gelöscht !')) {
            const attrKey = row.key;
            const entity = this.props.entitySelected;
            const structureData = this.state.structureData;
            if (structureData[entity].ATTS) {
                const attIndex = structureData[entity].ATTS.findIndex((a: any) => a.KEY === attrKey);
                if (attIndex >= 0) {
                    structureData[entity].ATTS.splice(attIndex, 1);
                }
            }
            this.setState({ structureData });
            this.props.sendEntityStructure(
                entity,
                structureData[entity]
            );
        }
    }

    onBatchDelete() {
        // console.log(this.checkedRows);
        if (this.checkedRows.length > 0 &&
            confirm('Wollen Sie die ausgewählten Felder wirklich entfernen?')) {
            const entity = this.props.entitySelected;
            const structureData = this.state.structureData;
            if (structureData[entity].ATTS) {
                this.checkedRows.forEach((attrKey: string) => {
                    const attIndex = structureData[entity].ATTS.findIndex((a: any) => a.KEY === attrKey);
                    if (attIndex >= 0) {
                        structureData[entity].ATTS.splice(attIndex, 1);
                    }
                });
            }
            this.setState({ structureData });
            this.props.sendEntityStructure(
                entity,
                structureData[entity]
            );
        }
    }
}
